import { render, staticRenderFns } from "./BadgeAI.vue?vue&type=template&id=1042f15d"
import script from "./BadgeAI.vue?vue&type=script&lang=js"
export * from "./BadgeAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports